/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {ReactNode} from 'react';
import {withTranslation} from 'react-i18next';
import {LocalizedPageProps} from '@ion/applications/src/types/pages';

export interface DisplayContent extends LocalizedPageProps {
  children: ReactNode;
}

const Page = ({children}: DisplayContent) => <>{children}</>;

const DisplayContent = withTranslation([
  'common',
  'nav',
  'grids',
  'notifications',
  'timezones',
  'countries',
  'contacts',
  'states',
  'admin-groups',
  'admin-users',
  'admin-assets',
  'admin-devices',
  'groups'
])(Page);

export default DisplayContent;
